import {number, plugName} from './i18n.mjs';
import {S} from './strings.mjs';
import {CONNECTORS} from './decode.mjs';
import {haptic} from './haptics.mjs';
export const STEPS = [0, 3.7, 11, 22, 50, 100, 150, 300, Infinity];
// Price slider: 1..99 ct/kWh, the right stop (PRICE_ANY) means no price filter.
export const PRICE_MIN = 1, PRICE_MAX = 99, PRICE_ANY = 100;
export const defaults = () => ({plugs: new Set(['Type 2', 'CCS']), min: 0, max: Infinity, onlyFree: false, hideOut: true, maxPrice: Infinity});
// Pre-R43 status parameters, read only when the new one is absent (mapping in w2c/filters.py, LEGACY_STATUS).
export const LEGACY_STATUS = ['available', 'unknown', 'out'];
export const priceLimit = value => { const n = Number(value); return Number.isInteger(n) && n >= PRICE_MIN && n <= PRICE_MAX ? n : Infinity; };
export function readFilters(p) {
  const f = defaults();
  if (p.has('connectors')) f.plugs = new Set(p.get('connectors').split(',').filter(x => CONNECTORS.includes(x)));
  f.min = Math.max(0, Number(p.get('min_kw')) || 0);
  f.max = p.has('max_kw') ? Math.max(f.min, Number(p.get('max_kw')) || 0) : Infinity;
  f.min = STEPS[Math.min(7, Math.max(0, STEPS.findIndex(v=>v>=f.min)))];
  f.max = STEPS[Math.max(STEPS.indexOf(f.min)+1, STEPS.findIndex(v=>v>=f.max))];
  if (p.has('only_free')) f.onlyFree = p.get('only_free') === '1';
  else if (LEGACY_STATUS.some(k => p.has(k))) f.onlyFree = p.get('available') !== '0';
  f.hideOut = p.has('hide_out_of_service') ? p.get('hide_out_of_service') !== '0' : p.get('out') !== '1';
  if (p.has('max_price')) f.maxPrice = priceLimit(p.get('max_price'));
  return f;
}
// Count restrictions against an unrestricted map, not changes from defaults.
export function activeFilters(f) {
  return Number(f.plugs.size > 0 && CONNECTORS.some(n => !f.plugs.has(n))) + Number(f.min > 0 || f.max !== Infinity)
    + Number(f.onlyFree) + Number(f.hideOut) + Number(f.maxPrice !== Infinity);
}
export function deviations(f) {
  return CONNECTORS.filter(n => f.plugs.has(n) !== ['Type 2', 'CCS'].includes(n)).length + Number(f.min !== 0 || f.max !== Infinity)
    + Number(f.onlyFree) + Number(!f.hideOut) + Number(f.maxPrice !== Infinity);
}
export function filterParams(f, p = new URLSearchParams()) {
  if (CONNECTORS.some(n => f.plugs.has(n) !== ['Type 2', 'CCS'].includes(n))) p.set('connectors', CONNECTORS.filter(n => f.plugs.has(n)).join(','));
  if (f.min) p.set('min_kw', f.min);
  if (f.max !== Infinity) p.set('max_kw', f.max);
  if (f.onlyFree) p.set('only_free', '1');
  if (!f.hideOut) p.set('hide_out_of_service', '0');
  if (f.maxPrice !== Infinity) p.set('max_price', f.maxPrice);
  return p;
}
export function powerLabel(f) {
  const n = v => number(v);
  return f.min === 0 && f.max === Infinity ? S.all : f.max === Infinity ? S.powerFrom(n(Math.min(300,f.min)))
    : f.min === 0 ? S.powerTo(n(f.max)) : S.powerRange(n(f.min),n(f.max));
}
export const priceLabel = f => f.maxPrice === Infinity ? S.priceAny : S.priceUpTo(number(f.maxPrice));
const SWITCHES = [['only-free','onlyFree'], ['hide-out','hideOut']];
export function filterControls(f, changed) {
  const $ = id => document.getElementById(id);
  for (const name of CONNECTORS) {
    const label = document.createElement('label'); label.className = 'chip';
    const input = document.createElement('input'); input.type = 'checkbox'; input.value = name;
    input.onchange = () => { input.checked ? f.plugs.add(name) : f.plugs.delete(name); changed(); };
    const text = document.createElement('span'); text.className = 'chip-label'; text.textContent = plugName(name);
    label.append(input, text); $('connectors').append(label);
  }
  const sync = () => {
    for (const input of $('connectors').querySelectorAll('input')) {
      input.checked = f.plugs.has(input.value);
      const text = input.parentElement?.querySelector('.chip-label'); if (text) text.textContent = plugName(input.value);
    }
    $('min-kw').value = String(STEPS.findIndex(v => v >= f.min));
    $('max-kw').value = String(STEPS.findIndex(v => v >= f.max));
    $('power-value').textContent = powerLabel(f);
    const a = Number($('min-kw').value), b = Number($('max-kw').value);
    $('min-kw').setAttribute('aria-valuemax', b - 1); $('max-kw').setAttribute('aria-valuemin', a + 1);
    document.querySelector('.slider').style.setProperty('--from', `${a/8*100}%`);
    document.querySelector('.slider').style.setProperty('--to', `${b/8*100}%`);
    $('min-kw').setAttribute('aria-valuetext', S.kw(number(f.min)));
    $('max-kw').setAttribute('aria-valuetext', f.max === Infinity ? S.unlimited : S.kw(number(f.max)));
    for (const [id, key] of SWITCHES) $(id).checked = f[key];
    syncPrice();
  };
  // Dragging only moves the label; the index is rebuilt once on release (change), never per pixel. No haptics.
  const syncPrice = (value = f.maxPrice === Infinity ? PRICE_ANY : f.maxPrice) => {
    const shown = {...f, maxPrice: priceLimit(value)};
    $('max-price').value = String(value);
    $('price-value').textContent = priceLabel(shown);
    $('max-price').setAttribute('aria-valuetext', priceLabel(shown));
    $('max-price').parentElement.style.setProperty('--from', '0%');
    $('max-price').parentElement.style.setProperty('--to', `${(value - PRICE_MIN) / (PRICE_ANY - PRICE_MIN) * 100}%`);
  };
  $('max-price').oninput = () => syncPrice(Number($('max-price').value));
  $('max-price').onchange = () => {
    const next = priceLimit($('max-price').value);
    syncPrice(Number($('max-price').value));
    if (next !== f.maxPrice) { f.maxPrice = next; changed(); }
  };
  for (const [id, key] of [['min-kw','min'], ['max-kw','max']]) $(id).oninput = () => {
    const before = f[key];
    f[key] = STEPS[clampDetent(key, Number($(id).value), STEPS.indexOf(f.min), STEPS.indexOf(f.max))];
    if (f[key] !== before) detentHaptic();
    sync(); changed();
  };
  for (const [id, key] of SWITCHES) $(id).onchange = () => { f[key] = $(id).checked; changed(); };
  $('reset').onclick = () => { Object.assign(f, defaults()); sync(); changed(); };
  sync();
  return sync;
}

// A short tick per detent from the input event (fires once per value change, also for keyboard);
// see haptics.mjs for why Android may stay silent. iOS Safari has no vibrate.
export const detentHaptic = (nav = globalThis.navigator, now) => haptic(undefined, {nav, ...(now ? {now} : {})});

// The other handle stays put, including keyboard use.
export function clampDetent(key, value, lower, upper) { return key === 'min' ? Math.max(0, Math.min(value, upper - 1)) : Math.min(8, Math.max(value, lower + 1)); }
